import LensesStep from '@screens/configuration/lenses'

export default function LensesStepPage() {
  return <LensesStep />
}
